// extracted by mini-css-extract-plugin
export default {"container":"NotificationsCenter_container__0W4FC","wrapper":"NotificationsCenter_wrapper__DgrVx","menu":"NotificationsCenter_menu__8n3ji"};